import React, { Component } from "react"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import toastr from 'toastr'
import 'toastr/build/toastr.min.css'

//SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
import { validateToken, has_Permission } from '../../helpers/jwt-token-access/accessToken'
import { Button, Card, CardBody, Col, Container, Row, FormGroup} from "reactstrap"
import { Link } from "react-router-dom"
import { BaseUrl } from "../../helpers/Baseurl"
import Select from "react-select";
import { AvForm, AvField } from "availity-reactstrap-validation";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import default_img from '../../assets/images/noimg.jpeg'

import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

const customStyles = {
    overlay: {
        marginTop: '70px'
    }
}

const FilterOptions = [
  { 
		label: "Filter Options",
		options: [
              { label: "Name", value: "name__icontains" },
              { label: "Activity", value: 'activity__name__icontains' },   
              { label: "Type", value: 'activity_type__icontains' },  
              { label: "Place", value: 'place__name__icontains' },               
		]
	}
]


class Activities extends Component {
  constructor(props) {
    super(props)
    this.obj = JSON.parse(localStorage.getItem("authUser"))
    if (!this.obj){
        this.props.history.push('/logout')
    }else if (!validateToken(this.obj.access)){
        this.props.history.push('/logout')
    }
    if(!has_Permission(this.obj.user, 4, 'read' )){
      this.props.history.push('/dashboard')
    }
    this.state = {
      activity_id:"",
      alert_confirm : false,
      success_confirm : false,
      dynamic_title: "",
			dynamic_description: "",

      activities: [],
      page:1,
      sizePerPage:20,
      totalSize:0,
      searchText:"",

      search:"",
      selectedFilterOptions: { label: "Filter By", value: null },

      breadcrumbItems : [
        { title : "Planmans", link : "/dashboard" },
        { title : "Activities", link : "#" },
    ],
    }

    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000
      }

    this.handleActivityClicks = this.handleActivityClicks.bind(this)
    this.clearSearch = this.clearSearch.bind(this)
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this)
  }
  componentDidCatch(error) {
    // Changing the state to true
    // if some error occurs
    console.log(error)
    this.props.history.push('/dashboard')
    toastr.error("Something Went Wrong", "")
  }
  componentDidMount(){
    document.title = "Activities | Planmans"
  }

  async loadData(url , sizePerPage, page , searchText){
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
    };
    await fetch(url,requestOptions)
        .then(res => res.json())
        .then(
            (data) => {
                this.setState(()=>({ activities: data.results, totalSize:data.count , page:page, sizePerPage, searchText }))
            },
            (error) => {
                console.log(error, 'error--------------') 
            }
        ) 

  }

  handleCopyVehicle = id => {
    let data = {"activity_id":id}
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${this.obj.access}` },
      body: JSON.stringify(data)
      };
      fetch(`${BaseUrl}/api/activities/copy-added-activity/`,requestOptions)
          .then(res => 
              {if(res.status >= 400){
                  res.json()
                  .then(
                      (data) =>{  
                          console.log(data, "---data")
                          toastr.error("Something Went Wrong", "")
                          this.setState({
                            activity_id:"",
                            copy_success_confirm: false,
                            copy_alert_confirm : false,
                            }) 
                      }    
                  )
              }
              else{
                let url = `${BaseUrl}/api/activities/activities/?size=${this.state.sizePerPage}&&page=${1}`
                this.loadData(url , this.state.sizePerPage, 1 , "")
                  this.setState({
                    activity_id:"",
                    copy_success_confirm: true,
                    copy_alert_confirm : false,
                    dynamic_title: "Copied!",
                    dynamic_description: "Your Activity has been Copied."
                    })
              }    
          }
      )

  }

  handleSearchSubmit(e, values) {
    let search = `&search=${values.search}&field=${this.state.selectedFilterOptions.value}`
    this.setState({search})
    let url = `${BaseUrl}/api/activities/activities/?size=${this.state.sizePerPage}&page=${1}${search}`
    this.loadData(url , this.state.sizePerPage, 1 , "")
  }

  clearSearch =() => {
    let search = ""
    let selectedFilterOptions = { label: "Search By", value: null }
    this.setState({search, selectedFilterOptions})
    let url = `${BaseUrl}/api/activities/activities/?size=${this.state.sizePerPage}&page=${1}`
    this.loadData(url , this.state.sizePerPage, 1 , "")
  }

 handleActivityClicks = id => {   
    const requestOptions = {
      method: 'DELETE',
  
      };
        fetch(`${BaseUrl}/api/activities/activities/${id}/`,requestOptions)
              .then(res => 
                  {if(res.status >= 400){
                    console.log("error")
                  }
                  else{
                    let new_page = this.state.page
                    if(this.state.activities.length < 2){
                      new_page = new_page>1? new_page-1:1
                    }
                    let url = `${BaseUrl}/api/activities/activities/?size=${this.state.sizePerPage}&page=${new_page}`
                    url = this.state.searchText && this.state.searchText !== "" ? url+`&search=${this.state.searchText}`: url
                    this.loadData(url , this.state.sizePerPage, new_page , this.state.searchText)
                    this.setState({
                      activity_id:"",
                      success_confirm: true,
                      alert_confirm : false,
                      dynamic_title: "Deleted!",
                      dynamic_description: "Your Activity has been deleted.",
                      
                      
                      })   
                  }
              }
          )
  }

  handleTableChange = (type, { page, sizePerPage }) => {
    
    setTimeout(() => {
      let new_page = page
      let url = `${BaseUrl}/api/activities/activities/?size=${sizePerPage}&page=${new_page}`
      // if (searchText && this.state.searchText !== ""){
      //   new_page = this.state.searchText !== searchText? 1 : new_page
      //   url = `${BaseUrl}/api/activities/activities/?size=${sizePerPage}&page=${new_page}&search=${searchText}`
      // }
      if (this.state.search!== ""){
        url = url + this.state.search
      }

      this.loadData(url , sizePerPage, new_page , "")

    }, 1000);
  }

  render() {

    const { activities, page, sizePerPage, totalSize } = this.state

    //pagination customization
    const pageOptions = {
      page: page,
      sizePerPage: sizePerPage,
      totalSize: totalSize,
      custom: true,
    }

    const defaultSorted = [{
      dataField: 'id',
      order: 'asc'
    }];

    //Columns
    const activitiesColumns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
        formatter: (cellContent, row) => (
          `A-${row.id+100}`    
        )
      },
      {
        dataField: "images",
        text: "Image",
        isDummyField: true,
        formatter: (cellContent, row) => (
          row.image.length === 0?

         <img className="rounded avatar-sm" src={default_img} alt={row.name} /> :
         <img className="rounded avatar-sm" src={BaseUrl+row.image[0].image} onClick={() => this.setState({ isFits: true, img_src:BaseUrl+row.image[0].image, img_name:row.name  })} alt={row.name}/>

          )

      },
      {
        dataField: "name",
        text: "Name",
        sort: true,
        formatter: (cellContent, row) => (
          has_Permission(this.obj.user, 4, 'edit') ?
            <a 
              href={`/edit-activity/${row.id}`} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="me-3 text-dark"
            >
              {row.name}
            </a>
          : cellContent
        )
      }
      ,
      {
        dataField: "activity",
        text: "Activity",
        sort: true,
        formatter: (cellContent, row) => (
     
          row.activity.name ),
      },
      {
        dataField: "activity_type",
        text: "Type",
        sort: true,
      },
      {
        dataField: "place",
        text: "Place",
        sort: true,
        formatter: (cellContent, row) => (
     
          row.place?row.place.name:"" ),
      },
      {
        dataField: "created_by",
        text: "Created By",
        formatter: (cellContent, row) => (
          row.created_by?row.created_by.first_name+" "+row.created_by.last_name:"-"
        )
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        Style: { float: 'left' },
        formatter: (cellContent, row) => (
          <React.Fragment>
            <Link to="#" onClick={() => this.props.history.push(`/activity/${row.id}`) } className="me-3 text-secondary"><i className="mdi mdi-eye font-size-18"></i></Link>
            {has_Permission(this.obj.user, 4, 'create' )?
            <Link  to="#" onClick={() => this.setState({ copy_alert_confirm: true, activity_id:row.id })} className="me-3 text-secondary"><i className="mdi mdi-content-copy font-size-18"></i></Link>
            :null}
            {has_Permission(this.obj.user, 4, 'delete' )?
            <Link to="#" onClick={() => this.setState({ alert_confirm: true, activity_id:row.id })}  className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>
            :null}
            </React.Fragment>
        ),
      },
    ]

    return (
      <React.Fragment>
        <div className="page-content">
        {this.state.isFits ? (
          <Lightbox
            reactModalStyle = {customStyles}
            mainSrc={this.state.img_src}
            enableZoom={false}
            imageCaption={
              `Image : ${this.state.img_name}`
            }
            onCloseRequest={() => this.setState({ isFits: false })}
          />):null}
          
          <Container fluid>
          <Breadcrumbs title="All Activities" breadcrumbItems={this.state.breadcrumbItems} />
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      data={activities}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={activities}
                          columns={activitiesColumns}
                          remote
                          bootstrap4
                          search
                        >
                          
                          {toolkitProps => (
                            <React.Fragment>
                              
                              <Row className="mb-2">
                              <Col sm="8">
                                  <Row>
                                    <Col sm='3'>
                                      <div className="mb-3 search-box" style={{borderRadius: "30px"}}>
                                          <Select  
                                              value= {this.state.selectedFilterOptions}
                                              onChange={(e) => this.setState({selectedFilterOptions: e})}
                                              options={FilterOptions}
                                              classNamePrefix="select2-selection"
                                          />
                                      </div>
                                    </Col>
                                    {this.state.selectedFilterOptions.value?
                                   
                                      <Col sm='9'>
                                          <AvForm className="needs-validation" onValidSubmit={this.handleSearchSubmit} >
                                      
                                            <Row>
                                              <Col md="6">
                                                
                                              <div className="search-box mb-2">
                                                <div className="position-relative">
                                                  <AvField
                                                    name="search"
                                                    placeholder={this.state.selectedFilterOptions.label}
                                                    type="text"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="search"
                                                  />
                                                </div>
                                              </div>
                                              </Col> 
                                              <Col md="6">
                                                
                                              <FormGroup className="mb-0 mt-1">

                                                <Button type="submit" color="primary" className="btn-rounded me-2">
                                                <i className="mdi mdi-filter-outline me-1" />
                                                    Apply Filter
                                                </Button>{" "}
                                                {this.state.search!== ""?
                                                    <Button type="button" color="secondary" onClick={() => this.clearSearch()} className="btn-rounded me-1">
                                                    <i className="mdi mdi-close me-1" />{" "}
                                                      Clear
                                                    </Button>
                                                  :null}
                                                

                                              </FormGroup>     
                                              </Col> 
                                            </Row>
                                        </AvForm>
                                      </Col>
                                    :null}
                                  </Row>
                                  
                                </Col>
                                <Col sm="4">
                                  <div className="text-sm-end">
                                  {has_Permission(this.obj.user, 4, 'create' )?
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded mb-2 me-2"
                                      onClick={() => this.props.history.push("/new-activity")}
                                    >
                                      <i className="mdi mdi-plus me-1" />{" "}
                                      Add Activity
                                    </Button>
                                    :null}
                                  </div>
                                </Col>
                              </Row>
                              <div className="table-responsive">

                                <BootstrapTable
                                  remote
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  responsive
                                  bordered={false}
                                  striped={false}
                                  defaultSorted={defaultSorted}
                                  headerWrapperClasses={"table-light"}
                                  columns = {activitiesColumns}
                                  onTableChange={ this.handleTableChange }
                                />
                                
                              </div>
                              <Row>
                                <Col sm='6'>
                                  <div className="pagination pagination-rounded mb-2">
                                    <PaginationTotalStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                                <Col sm='6'>
                                  <div className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </div>
                                </Col>
                              </Row>
                              
                              {this.state.alert_confirm ? (
                                  <SweetAlert
                                  title="Are you sure?"
                                  warning
                                  showCancel
                                  confirmBtnBsStyle="success"
                                  cancelBtnBsStyle="danger"
                                  onConfirm={() => this.handleActivityClicks(this.state.activity_id)}
                                  onCancel={() =>
                                      this.setState({
                                          alert_confirm: false,
                                          activity_id:"",

                                      })
                                  }
                                  >
                                  You won't be able to revert this!
                                  </SweetAlert>
                              ) : null}

                              {this.state.success_confirm ? (
                                <SweetAlert
                                success
                                title={this.state.dynamic_title}
                                confirmBtnBsStyle="success"
                                cancelBtnBsStyle="danger"
                                onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                                >
                                    {this.state.dynamic_description}
                                </SweetAlert>
                                )
                                : null
                              }
                              {this.state.copy_alert_confirm ? (
                                  <SweetAlert
                                  title="Are you sure?"
                                  warning
                                  showCancel
                                  confirmBtnBsStyle="success"
                                  cancelBtnBsStyle="danger"
                                  onConfirm={() => this.handleCopyVehicle(this.state.activity_id)}
                                  onCancel={() =>
                                      this.setState({
                                          copy_alert_confirm: false,
                                          activity_id:"",

                                      })
                                  }
                                  >
                                  You Really Want to replicate it !
                                  </SweetAlert>
                              ) : null}

                              {this.state.copy_success_confirm ? (
                                <SweetAlert
                                success
                                title={this.state.dynamic_title}
                                confirmBtnBsStyle="success"
                                cancelBtnBsStyle="danger"
                                onConfirm={() => this.setState({ copy_success_confirm: false, copy_alert_confirm : false })}
                                >
                                    {this.state.dynamic_description}
                                </SweetAlert>
                                  )
                                  : null
                                }
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    )
  }
}

export default Activities